import DiplomaShow from './DiplomaShow';
export default DiplomaShow;
